import RedExclamationAnimatedIcon from "@/Shared/Animations/RedExclamationAnimatedIcon";
import type { ReactNode } from "react";

interface BookShipmentDetailsErrorWarningProps {
  children: ReactNode;
}

export function BookShipmentDetailsErrorWarning({
  children,
}: BookShipmentDetailsErrorWarningProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        paddingBottom: "30px",
      }}
    >
      <RedExclamationAnimatedIcon />
      {children}
    </div>
  );
}
